import IMAGES from '@/assets/images';
import CustomImage from '@/components/CustomImage';
import {
  Call02Icon,
  ChevronDownIcon,
  CirclePlusIcon,
  MailIcon,
  PencilEdit02Icon,
} from '@/icons';
import NextIcon from '@/pages/Admin/Employee/Leave/_icons/NextIcon';
import PreviousIcon from '@/pages/Admin/Employee/Leave/_icons/PreviousIcon';
import {
  Button,
  Calendar,
  Checkbox,
  DatePicker,
  Flex,
  Form,
  Input,
  Select,
  Space,
} from 'antd';
import dayjs from 'dayjs';
import { useState } from 'react';

export default function AssignInterview() {
  const [form] = Form.useForm();
  const [value, setValue] = useState(dayjs());

  const [, setSelected] = useState(dayjs());
  const interviewDate = Form.useWatch('interviewDate', form);

  const onSelect = (newValue: any) => {
    setValue(newValue);
    setSelected(newValue);
  };

  const handleSubmit = (values: any) => {
    console.log(values);
    // Handle form submission here
  };

  return (
    <Form
      form={form}
      size="large"
      layout="vertical"
      className="custom-form space-y-6"
      onFinish={handleSubmit}
      initialValues={{
        questions: [{ question_set: '', mark: '' }],
      }}
    >
      <div>
        <div className="mt-5">
          <div className="justify-start text-white text-lg font-normal">
            User Assigned
          </div>

          <div className="my-3 grid grid-cols-2 md:grid-cols-3 gap-3  mt-5">
            {[1, 2, 3].map((_, i) => (
              <Flex
                key={i}
                align="start"
                gap={10}
                className="p-2.5 rounded-lg bg-[#1E293B]"
              >
                <Space>
                  <CustomImage
                    alt="User"
                    width={25}
                    height={25}
                    src={IMAGES.avatar}
                    className="rounded-full"
                  />
                </Space>
                <div>
                  <Space>
                    <div className="text-center justify-start text-white text-base font-medium">
                      Afsana Tabassum
                    </div>
                  </Space>
                  <Space size={8}>
                    <MailIcon size={12} className="text-white" />
                    <div className="justify-start text-white text-xs font-normal">
                      tajulislam@gmail.com
                    </div>
                  </Space>

                  <Space size={8}>
                    <Call02Icon size={12} className="text-white" />
                    <div className="justify-start text-white text-xs font-normal">
                      +88017584655
                    </div>
                  </Space>
                </div>
                <Space>
                  <Checkbox className="custom-check" />
                </Space>
              </Flex>
            ))}
          </div>
        </div>

        <div className="w-full dark:bg-theme-slate-800 border dark:border-theme-gray-700 rounded-xl text-white p-3 mt-5 mb-5">
          {/* Ant Design Calendar */}
          {/* Custom Calendar Header */}
          <div className="flex items-start justify-center mb-4 text-xl font-semibold ">
            <button
              type="button"
              onClick={() => setValue(value.subtract(1, 'month'))}
              className="px-2 text-gray-300 hover:text-white text-base mt-2"
            >
              <PreviousIcon />
            </button>

            <div className="flex-col justify-center text-center">
              <div>{value.format('MMMM')}</div>
              <div className="text-white text-sm font-bold">
                {value.format('YYYY')}
              </div>
            </div>

            <button
              type="button"
              onClick={() => setValue(value.add(1, 'month'))}
              className="px-2 text-gray-300 hover:text-white text-base mt-2"
            >
              <NextIcon />
            </button>
          </div>

          {/* Ant Design Calendar */}
          <Calendar
            fullscreen={false}
            value={value}
            onSelect={onSelect}
            onPanelChange={(val) => setValue(val)}
            headerRender={() => null}
            className="custom-calendar"
            disabledDate={(current) =>
              current && current < dayjs().startOf('day')
            }
          />
        </div>

        <Form.Item
          label="Interview Method"
          name="interview_method"
          rules={[
            {
              required: true,
              message: 'Please select interview method',
            },
          ]}
        >
          <Select
            placeholder="Select"
            className="transparent-select"
            suffixIcon={<ChevronDownIcon size={24} className="text-white" />}
            options={[
              { label: 'Online', value: 'online' },
              { label: 'Onsite', value: 'onsite' },
            ]}
          />
        </Form.Item>

        <Form.Item
          label="Online Meeting Link"
          name="onlineMeetingLink"
          rules={[
            {
              required: true,
              message: 'Please enter online meeting link',
            },
          ]}
        >
          <Input className="transparent-input" />
        </Form.Item>

        <div className="grid grid-cols-2 gap-6">
          <Form.Item
            label="Interview Date"
            name="interviewDate"
            rules={[
              {
                required: true,
                message: 'Please select interview date',
              },
            ]}
          >
            <DatePicker
              picker="date"
              format="YYYY/MM/DD"
              placeholder="YYYY/MM/DD"
              style={{ width: '100%' }}
              className="transparent-picker"
              disabledDate={(current) =>
                current && current < dayjs().startOf('day')
              }
            />
          </Form.Item>

          <Form.Item
            label="Select Interview Time"
            name="interviewTime"
            rules={[
              {
                required: true,
                message: 'Please select interview time',
              },
            ]}
          >
            <DatePicker
              picker="time"
              format="HH:mm:ss"
              placeholder="HH:MM:SS"
              style={{ width: '100%' }}
              className="transparent-picker"
              disabledTime={() => {
                if (
                  interviewDate &&
                  dayjs(interviewDate).isSame(dayjs(), 'day')
                ) {
                  const now = dayjs();
                  return {
                    disabledHours: () => {
                      const hours = [];
                      for (let i = 0; i < now.hour(); i++) {
                        hours.push(i);
                      }
                      return hours;
                    },
                    disabledMinutes: (selectedHour) => {
                      if (selectedHour === now.hour()) {
                        const minutes = [];
                        for (let i = 0; i < now.minute(); i++) {
                          minutes.push(i);
                        }
                        return minutes;
                      }
                      return [];
                    },
                    disabledSeconds: (selectedHour, selectedMinute) => {
                      if (
                        selectedHour === now.hour() &&
                        selectedMinute === now.minute()
                      ) {
                        const seconds = [];
                        for (let i = 0; i < now.second(); i++) {
                          seconds.push(i);
                        }
                        return seconds;
                      }
                      return [];
                    },
                  };
                }
                return {};
              }}
            />
          </Form.Item>
        </div>

        <div>
          <div className="justify-start pb-3 border-b border-slate-600 mt-5">
            <span className="text-white text-base font-normal">
              Set Interview Question Set & Mark{' '}
            </span>
            <span className="text-rose-500 text-base font-normal">*</span>
          </div>
          <Form.List name="questions">
            {(fields, { add }) => (
              <>
                {fields.map(({ key, name, ...restField }) => (
                  <Flex
                    key={key}
                    justify="space-between"
                    gap={16}
                    className="mt-5"
                  >
                    {/* Question Input */}
                    <Form.Item
                      {...restField}
                      name={[name, 'question_set']}
                      className="w-full"
                      rules={[{ required: true, message: 'Enter question' }]}
                    >
                      <Input
                        size="large"
                        placeholder="--"
                        suffix={
                          <PencilEdit02Icon size={20} className="text-white" />
                        }
                        className="!bg-transparent !border-theme-slate-700"
                      />
                    </Form.Item>

                    {/* Mark Input */}
                    <Form.Item
                      {...restField}
                      name={[name, 'mark']}
                      className="w-20 shrink-0"
                      rules={[{ required: true, message: 'Enter mark' }]}
                    >
                      <Input
                        size="large"
                        placeholder=""
                        suffix={
                          <PencilEdit02Icon size={20} className="text-white" />
                        }
                        className="!bg-transparent !border-theme-slate-700"
                      />
                    </Form.Item>
                  </Flex>
                ))}

                {/* Add Button */}
                <button
                  type="button"
                  onClick={() => add({ question_set: '', mark: '' })}
                  className="w-full flex items-center mt-5"
                >
                  <div className="flex-1 border-b border-dashed border-theme-primary" />

                  <div className="mx-3 bg-theme-slate-800 z-10">
                    <CirclePlusIcon size={20} className="text-theme-primary" />
                  </div>

                  <div className="flex-1 border-b border-dashed border-theme-primary" />
                </button>
              </>
            )}
          </Form.List>
        </div>

        <div className="flex justify-end">
          <div
            className="p-2.5 rounded-lg outline outline-1 outline-offset-[-1px]
           outline-gray-700 inline-flex justify-end items-start gap-10 mt-5"
          >
            <div className="justify-start text-white text-lg font-normal">
              Total Mark
            </div>
            <div className="justify-start text-teal-500 text-xl font-bold">
              100
            </div>
          </div>
        </div>

        <div className="flex justify-end mt-6">
          <Button className="btn-primary min-w-20" htmlType="submit">
            Confirm
          </Button>
        </div>
      </div>
    </Form>
  );
}
